import React from 'react';
import styled from 'styled-components';

const Navbar: React.FC = () => {
  const handleScroll = (id: string) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Nav>
      <NavLink onClick={() => handleScroll('slub')}>Ślub</NavLink>
      <NavLink onClick={() => handleScroll('wesele')}>Wesele</NavLink>
      <NavLink onClick={() => handleScroll('program')}>Program</NavLink>
      <NavLink onClick={() => handleScroll('szczegoly')}>Szczegóły</NavLink>
      <NavLink onClick={() => handleScroll('kontakt')}>Kontakt</NavLink>
      <NavLink onClick={() => handleScroll('galeria')}>Galeria</NavLink>
    </Nav>
  );
};

const Nav = styled.nav`
  position: fixed;
  bottom: 0;
  width: 100%;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  padding: 10px 0;
  box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: flex;
  justify-content: space-around;

  @media (min-width: 769px) {
    position: fixed;
    top: 0;
    bottom: unset;
    justify-content: center;
    gap: 20px;
  }
`;

const NavLink = styled.button`
  background: none;
  border: none;
  color: #333;
  font-family: 'Darker Grotesque', sans-serif;
  font-size: 1rem;
  cursor: pointer;
  transition: color 0.3s, transform 0.2s;

  &:hover {
    color: #007bff;
    transform: scale(1.1);
  }

  @media (min-width: 769px) {
    font-size: 1.2rem;
  }
`;

export default Navbar;